import { DatePicker, DatePickerProps } from 'antd';
import { FC } from 'react';
import './style.scss';
import { SvgPaginationNext } from '../svg/SvgPaginationNext';
import { SvgPaginationPrev } from '../svg/SvgPaginationPrev';
import SvgDatePicker from '../svg/SvgDatePicker';
import { YEAR_MONTH_DATE_FORMAT_JP } from '../../constants/common';

export interface DatePickerWrapProps extends DatePickerProps {
  width?: number | 'full';
}

const DatePickerWrap: FC<DatePickerWrapProps> = (props) => {
  const { className, popupClassName, width, format, ...otherProps } = props;

  return (
    <>
      <DatePicker
        {...otherProps}
        superNextIcon={null}
        superPrevIcon={null}
        nextIcon={<SvgPaginationNext />}
        prevIcon={<SvgPaginationPrev />}
        showNow={false}
        suffixIcon={<SvgDatePicker />}
        className={`custom_date-picker ${width ? `width-${width}` : ''} ${className || ''}`}
        popupClassName={`custom_date-picker-popup ${popupClassName || ''}`}
        format={format || YEAR_MONTH_DATE_FORMAT_JP}
      />
    </>
  );
};

export default DatePickerWrap;
